import {
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import {NgClass} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {IDocumentDto} from '../../store/portal/portal.model';
import {Constants} from '../../constants/constants';
import {FileType} from '../../enums/file.enum';

@Component({
  selector: 'app-document-card',
  imports: [MatTooltipModule, TranslatePipe, NgClass],
  templateUrl: './document-card.component.html',
  styleUrl: './document-card.component.scss',
})
export class DocumentCardComponent {

  public readonly document: InputSignal<IDocumentDto | undefined> = input<IDocumentDto>();

  public readonly previewMode: InputSignal<boolean> = input<boolean>(false);

  public readonly downloadDocument: OutputEmitterRef<string> = output<string>();

  getNameIconByFileTitle(title: string | undefined): string {
    return this.getIconNameByFileType(this.getFileTypeByFileName(title));
  }

  getFileTypeByFileName(fileName: string | undefined): string | null {
    const arrFileName = fileName?.split(Constants.DOT) ?? [];
    return arrFileName[arrFileName.length - 1] || null;
  }

  getIconNameByFileType(fileType: string | null): string {
    const types = {
      [FileType.PDF]: 'icon--file-pdf',
      [FileType.XLS]: 'icon--file-xls',
      [FileType.XLSX]: 'icon--file-xls',
    };
    return (fileType && types[fileType]) || 'icon--nodoc';
  }

  downloadDocumentById(id: string | undefined): void {
    if (!id) {
      return;
    }
    this.downloadDocument.emit(id);
  }

}
